import script from "./SentenceCSS.vue?vue&type=script&setup=true&lang=js"
export * from "./SentenceCSS.vue?vue&type=script&setup=true&lang=js"

import "./SentenceCSS.vue?vue&type=style&index=0&id=41c93566&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c93566"]])

export default __exports__